module.exports = __webpack_public_path__ + "img/title.46ee6207.png";